const DocumentNotFound = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="105"
			height="112"
			viewBox="0 0 105 112"
			fill="none"
		>
			<g clipPath="url(#clip0_4689_12436)">
				<path
					d="M18.4527 2.06152L73.8243 2.14119C78.7129 2.14119 82.6748 6.10861 82.6748 10.9842L82.563 101.111C82.563 105.987 78.585 109.939 73.6965 109.939L10.4169 109.859C5.52837 109.859 1.56641 105.891 1.56641 101.016L1.67824 17.4054L18.4527 2.06152Z"
					fill="#EAF1FC"
					stroke="#AFC1DB"
					strokeWidth="3.92"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M57.1849 33.554H13.5234"
					stroke="#AFC1DB"
					strokeWidth="3.92"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M57.1849 46.8982H13.5234"
					stroke="#AFC1DB"
					strokeWidth="3.92"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M57.1849 60.2502H13.5234"
					stroke="#AFC1DB"
					strokeWidth="3.92"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M42.1199 73.5945H13.5234"
					stroke="#AFC1DB"
					strokeWidth="3.92"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.4522 2.06152V10.9364C18.4522 14.7764 15.3369 17.8834 11.4868 17.8834H1.67773L18.4522 2.06152Z"
					fill="white"
					stroke="#AFC1DB"
					strokeWidth="3.92"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M73.5829 99.3905C90.0689 99.3905 103.433 86.0613 103.433 69.619C103.433 53.1766 90.0689 39.8474 73.5829 39.8474C57.097 39.8474 43.7324 53.1766 43.7324 69.619C43.7324 86.0613 57.097 99.3905 73.5829 99.3905Z"
					fill="white"
					stroke="#AFC1DB"
					strokeWidth="3.92"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M64.3652 60.4253L82.8011 78.8124"
					stroke="#AFC1DB"
					strokeWidth="3.92"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M82.8011 60.4253L64.3652 78.8124"
					stroke="#AFC1DB"
					strokeWidth="3.92"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M94.1113 91.2246L103.433 100.53"
					stroke="#AFC1DB"
					strokeWidth="3.92"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4689_12436">
					<rect
						width="105"
						height="111"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default DocumentNotFound;
